// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from "@thd-olt-component-react/router";

const ssr = typeof window === "undefined" || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.Home = (await import("./pages/Home")).HomeHOC;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => {
  return {
    home: {
      name: "HomeHOC",
      componentName: "HomeHOC",
      chunk: () => import(
        "./pages/Home"
      ),
      get component() {
        return ssr
        // eslint-disable-next-line no-undef
          ? serverPages.Home
          : currentRouteName === "HomeHOC"
            ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk() // eslint-disable-line
              .then((pageModule) => ({ default: pageModule?.HomeHOC })));
      },
      path: "/:context?/*",
      prefetch: [],
      channel: null,
      varnish: false,
    },
  };
};
